export const games = [
  {
    id: 'void-protocol',
    title: 'VOID PROTOCOL',
    genre: 'Sci-Fi · Ação',
    status: 'Em Desenvolvimento',
    statusColor: '#00A3FF',
    year: '2025',
    description: 'Em um futuro onde a memória humana pode ser hackeada, você é o único agente capaz de atravessar o Void — uma dimensão entre o real e o digital — para recuperar o que foi roubado.',
    longDescription: 'Void Protocol é um jogo de ação em terceira pessoa ambientado em 2087. A humanidade alcançou a transferência de consciência, mas um grupo sombrio chamado NULL começou a apagar memórias de pessoas ao redor do mundo. Você é KAI-7, o único agente com acesso ao Void — uma dimensão entre o real e o digital.\n\nSua missão: recuperar as memórias roubadas antes que a identidade humana seja completamente apagada. Navegue entre zonas de dados corrompidos, enfrente guardiões do NULL e reconstrua os fragmentos de quem você era.',
    tags: ['Ação', 'Sci-Fi', 'Stealth', 'Single Player'],
    accentColor: '#00A3FF',
    gradient: 'linear-gradient(135deg, #001a3a 0%, #000820 100%)',
    emoji: '🔷',
    featured: true,
    platforms: ['PC', 'Console'],
    webGame: false,
    releaseDate: 'TBA 2026',
    developer: 'Guebly Games',
    features: ['Mundo aberto em realidade digital', 'Sistema de memória fragmentada', 'IA adaptativa dos inimigos', 'Modo cooperativo 2P'],
  },
  {
    id: 'raizes',
    title: 'RAÍZES',
    genre: 'RPG · Aventura',
    status: 'Conceito',
    statusColor: '#C800FF',
    year: '2026',
    description: 'Uma jornada pelo Brasil profundo. RPG de mundo aberto onde a mitologia brasileira — Cuca, Saci, Boto — são as forças que regem a realidade de um país esquecido pelo tempo.',
    longDescription: 'RAÍZES é um RPG de mundo aberto inspirado no folclore e na cultura brasileira. Você é Yaci, uma jovem de origem indígena que descobre ter o dom de ver os espíritos que moldam a terra.\n\nEm uma viagem do Nordeste até a Amazônia, você vai desvendar conspirações, construir alianças com criaturas do folclore e enfrentar forças que querem apagar a memória cultural do Brasil. Um RPG brasileiro, para o mundo.',
    tags: ['RPG', 'Open World', 'Folclore BR', 'Single Player'],
    accentColor: '#C800FF',
    gradient: 'linear-gradient(135deg, #1a0030 0%, #0d0020 100%)',
    emoji: '🌿',
    featured: true,
    platforms: ['PC'],
    webGame: false,
    releaseDate: 'TBA 2027',
    developer: 'Guebly Games',
    features: ['Mundo aberto inspirado no Brasil real', 'Folclore como mecânica de jogo', 'Narrativa em português BR', 'Trilha sonora original brasileira'],
  },
  {
    id: 'drum-kit',
    title: 'DRUM KIT',
    genre: 'Música · Ritmo',
    status: 'Disponível',
    statusColor: '#00FF88',
    year: '2025',
    description: 'Bateria virtual completa com 9 pads, visualizador de frequência em tempo real e compositor automático. Toque pelo teclado ou clique nos pads.',
    longDescription: 'Uma bateria virtual completamente redesenhada com a identidade Guebly. 9 instrumentos distintos, visualizador de frequência em tempo real, compositor automático com BPM e suporte total a teclado (Q W E A S D Z X C).\n\nPerfeito para quem quer criar batidas na hora, explorar ritmos ou simplesmente bater numas teclas e se sentir músico.',
    tags: ['Música', 'Ritmo', 'Teclado', 'Web'],
    accentColor: '#00FF88',
    gradient: 'linear-gradient(135deg, #001a0d 0%, #000d08 100%)',
    emoji: '🥁',
    featured: false,
    platforms: ['Web'],
    webGame: true,
    route: '/play/drum-kit',
    releaseDate: 'Disponível agora',
    developer: 'Guebly Games',
    features: ['9 pads de bateria', 'Compositor automático', 'Suporte a teclado', 'Visualizador em tempo real'],
  },
  {
    id: 'memory-game',
    title: 'MEMORY',
    genre: 'Puzzle · Memória',
    status: 'Disponível',
    statusColor: '#00FF88',
    year: '2025',
    description: 'Jogo da memória com 3 dificuldades, timer regressivo e sistema de pontuação. As cartas aparecem brevemente no início — memorize e encontre os pares!',
    longDescription: 'Memory é um jogo de cartas clássico reimaginado com a estética Guebly Games. No início de cada partida, todas as cartas são reveladas brevemente para você memorizar — depois fecham e o desafio começa.\n\nTrês níveis de dificuldade, timer regressivo, pontuação por velocidade e acurácia. Quanto mais rápido e com menos erros, maior o score. Confete de vitória garantido.',
    tags: ['Puzzle', 'Memória', 'Timer', 'Web'],
    accentColor: '#C800FF',
    gradient: 'linear-gradient(135deg, #1a0030 0%, #0d001a 100%)',
    emoji: '🃏',
    featured: false,
    platforms: ['Web'],
    webGame: true,
    route: '/play/memory-game',
    releaseDate: 'Disponível agora',
    developer: 'Guebly Games',
    features: ['Preview das cartas no início', '3 dificuldades', 'Timer regressivo', 'Sistema de pontuação'],
  },
  {
    id: 'tic-tac-toe',
    title: 'TIC TAC TOE',
    genre: 'Estratégia · Clássico',
    status: 'Disponível',
    statusColor: '#00FF88',
    year: '2025',
    description: 'Jogo da velha com IA imbatível (algoritmo Minimax), modo 2 jogadores, 3 dificuldades e placar persistente. Consegue vencer a máquina?',
    longDescription: 'O clássico Jogo da Velha com IA baseada em Minimax com alpha-beta pruning. No modo Difícil, a IA joga perfeitamente — não dá para vencer, apenas empatar.\n\nTrês dificuldades: Fácil (a IA erra às vezes), Médio (desafiador) e Difícil (imbatível). Também disponível para 2 jogadores local com placar persistente na sessão.',
    tags: ['Estratégia', 'IA', 'Minimax', 'Web'],
    accentColor: '#FFB800',
    gradient: 'linear-gradient(135deg, #1a1000 0%, #0d0800 100%)',
    emoji: '⚔️',
    featured: false,
    platforms: ['Web'],
    webGame: true,
    route: '/play/tic-tac-toe',
    releaseDate: 'Disponível agora',
    developer: 'Guebly Games',
    features: ['IA Minimax imbatível', '3 dificuldades', 'Modo 2 jogadores', 'Placar da sessão'],
  },
];

export const getFeatured = () => games.filter(g => g.featured);
export const getGameById = (id) => games.find(g => g.id === id);
export const getWebGames = () => games.filter(g => g.webGame);
